import React from 'react';

const RecentSearches = ({ recentSearches, onClear, onRecentClick }) => {
  if (recentSearches.length === 0) return null;

  return (
    <div className="mt-1 px-1">
      <div className="flex justify-between mb-3">
        <h2 className="text-md font-semibold text-gray-700">Recent Searches</h2>
        <button
          onClick={onClear}
          className="text-sm text-red-500 font-medium hover:underline"
        >
          clear
        </button> 
      </div>

 <div className="grid grid-cols-2 gap-2 px-1">
  {recentSearches.slice(0, 10).map((item, idx) => (
    <button
      key={idx}
      onClick={() => onRecentClick(item)}
      className="flex items-center space-x-2 bg-white border border-gray-200 rounded-full px-3 py-1.5 shadow-sm hover:bg-gray-100 transition w-full"
    >
      {item.image ? (
        <img
          src={item.image}
          alt={item.name}
          className="w-5 h-5 rounded-full object-cover flex-shrink-0"
        />
      ) : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-4 w-4 text-gray-500 flex-shrink-0"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
          />
        </svg>
      )}
      <span className="text-sm text-gray-700 truncate w-full text-left">
        {item.name}
      </span>
    </button>
  ))}
</div>



    </div>
  );
};

export default RecentSearches;
